<template>
  <div id="app">
    <div>
      <Login v-if="state === 'LOGIN'" @onSocketConnected="onSocketConnected"
             @update="update"></Login>
      <Scene v-if="state === 'SCENE'" :socket="socket" :token="token" :host="host" @onJoinFail="stateLogin"></Scene>
    </div>
  </div>
</template>

<script>
  import {ref} from 'vue';
  import Login from './components/Login.vue';
  import Scene from './components/Scene.vue';

  let data = {
    state: 'LOGIN',
    socket: null,
    token: '',
    host: ''
  };
  export default {
    name: 'App',

    components: {
      Login,
      Scene
    },

    setup() {
      let socket = ref({});
      const state = ref('LOGIN');
      const host = ref('');
      const token = ref('');

      function update(data) {
        token.value = data.token;
        host.value = data.host;
        const formName = sessionStorage.getItem("name");
        
        document.title = `${data.code} (${formName})`;
        
        setTimeout(()=> {
          // document.title = data.code;
          document.title = `${data.code} (${formName})`;
        }, 7000)
      }

      function stateLogin() {
        state.value = 'LOGIN';
        document.title = "SimsUShare Exercise Login";
      }

      function onSocketConnected(socket_obj) {
        socket.value = socket_obj;
        state.value = 'SCENE';
      }

      return {state, socket, token, host, update, stateLogin, onSocketConnected}
    }
  }
</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body,
  .height-100 {
    height: 100%;
  }
</style>
